import Vue from 'vue'
import request from '@/api/request.js';

// 订单列表
export const getOrderListPage = (data) => {
    return request({
        url: '/admin/order/adm/order/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 订单详情
export const getOrderDetail = (data) => {
    return request({
        url: '/admin/adm/order/getDetail',
        method: 'post',
        type: 'json',
        data
    })
}

// 订单详情
export const getAuditInfoByOrderId = (data) => {
    return request({
        url: '/order/adm/order/getAuditInfoByOrderId',
        method: 'post',
        type: 'json',
        data
    })
}

// 审核订单
export const auditRemitOrder = (data) => {
    return request({
        url: '/order/adm/order/auditRemitOrder',
        method: 'post',
        type: 'json',
        data
    })
}

// 重新上传凭证
export const submitRemitVoucher = (data) => {
    return request({
        url: '/order/adm/order/submitRemitVoucher',
        method: 'post',
        type: 'json',
        data
    })
}

// 通过订单id查询发票信息
export const getInvoiceByOrderId = (data) => {
    return request({
        url: '/order/adm/invoice/getInvoiceByOrderId',
        method: 'post',
        type: 'json',
        data
    })
}

// 租户列表
export const getSelectCompanyList = (params) => {
    return request({
        url: '/base/adm/company/getSelectCompanyList',
        method: 'get',
        params
    })
}

// 租户列表(筛选代理商/分销商)
export const getCompanyListByAgent = (params) => {
    return request({
      url: '/base/adm/company/getCompanyListByAgent',
        method: 'get',
        params
    })
}

// 重新签协议
export const resignAgreement = (data) => {
  return request({
    url: '/order/adm/order/resignAgreement',
    method: 'post',
    type: 'json',
    data
  })
}

// 添加结算单
export const addBillOrder = (data) => {
  return request({
    url: '/order/adm/bill/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取易票联跳转路径
export const getYPLPayPath = data => {
  return request({
    url: 'order/app/order/yplPay',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取结算单列表
export const pageByBillListPage = (data) => {
  let url = '/order/adm/bill/page'
  if (Vue.prototype.checkAdmin()) {
    url = '/order/adm/bill/pageByAdmin'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 结算单审核
export const billOrderAudit = (data) => {
  return request({
    url: '/order/adm/audit/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 关联订单
export const pageByBill = (data) => {
  return request({
    url: '/order/adm/order/pageByBill',
    method: 'post',
    type: 'json',
    data
  })
}

// 结算单详情
export const getBillDetails = (data, next = false) => {
  let url = '/order/adm/bill/details'
  if (next) {
    if (Vue.prototype.checkAdmin()) {
      url = '/order/adm/bill/nextByAdmin'
    } else {
      url = '/order/adm/bill/next'
    }
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 上传发票物流信息
export const uploadInvoice = (data) => {
  return request({
    url: '/order/adm/bill/uploadInvoice',
    method: 'post',
    type: 'json',
    data
  })
}
